<div class="dimBackground-blue" id="appBusy" *ngIf="(loaderService.isLoading | async) || enableLoader">
    <div class="spinner">
      <img height="75px" alt="busy" src="../../../assets/img/spinner.gif">
      <p>Loading...</p>
    </div>
</div>
